import { cn } from "@/lib/utils";

/**
 * A manifest section header: a small stencil label with a 1.5px ink bottom rule and optional
 * right-aligned mono meta ("1 model call · 11.4s", counts). Heads every major section
 * (CONTENT IDEAS, FACT BANK — MANIFEST, LINKEDIN — 3 OPTIONS).
 * See .flow/DESIGN-SPEC.md § signature elements (manifest header).
 */
export interface ManifestHeaderProps {
  /** The label text — rendered uppercase in Saira Stencil One. */
  label: React.ReactNode;
  /** Optional right-aligned mono meta line. */
  meta?: React.ReactNode;
  className?: string;
}

export function ManifestHeader({ label, meta, className }: ManifestHeaderProps) {
  return (
    <div
      className={cn(
        "flex items-end justify-between gap-3 pb-1.5 border-b-[1.5px] border-ink",
        className,
      )}
    >
      <span className="font-stencil uppercase text-ink text-sm tracking-[0.12em] leading-none">
        {label}
      </span>
      {meta != null && (
        <span className="font-mono text-steel-dark text-[11px] leading-none tabular-nums whitespace-nowrap">
          {meta}
        </span>
      )}
    </div>
  );
}

export default ManifestHeader;
